import { render, staticRenderFns } from "./blood-oxygen.vue?vue&type=template&id=3f3fece4&scoped=true"
import script from "./blood-oxygen.vue?vue&type=script&lang=js"
export * from "./blood-oxygen.vue?vue&type=script&lang=js"
import style0 from "./blood-oxygen.vue?vue&type=style&index=0&id=3f3fece4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f3fece4",
  null
  
)

export default component.exports